import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { ILocation } from 'bets.oddprovider.lib.common.ts/models'
import { LocationsApiClient } from '../../apiClient/locations'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface ILocationsAction extends IDefaultAction {
  payload?: ILocation[],
}

export interface ILocationsState extends IDefaultState {
  payload?: ILocation[],
}

const initState: ILocationsState = {}

export const locationsStateLoadFromApi = createAsyncThunk(
  'locationsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<ILocation>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const IapiResult: IApiClientResult<ApiResponseGetListData<ILocation>> = await new LocationsApiClient(axios).get({
      where: arg.where,
      sort: { name: 1 }
    })

    if (IapiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(IapiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return IapiResult
  }
)

export const locationsSlice = createSlice({
  name: 'locationsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(locationsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(locationsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(locationsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearLocations } = locationsSlice.actions
export default locationsSlice.reducer